import React from 'react'
import BreadCrumb from '../../Components/Common/BreadCrumb'
import { Col, Container, Row } from 'reactstrap'
import Widgets from '../../OrderingSystem/Dashboard/components/Widgets'
import ProjectsOverview from '../../OrderingSystem/Dashboard/components/ProjectsOverview'
import UpcomingSchedules from '../../OrderingSystem/Dashboard/components/UpcomingSchedules'

const Dashboard = () => {
  return (
    <div className='page-content'>
    <Container fluid>
                    <BreadCrumb title="Projects" pageTitle="Dashboards" />
<Row className="project-wrapper">
                        <Col xxl={8}>
                            <Widgets />
                        </Col>
                            <ProjectsOverview />
                       
                    </Row>
                    
    </Container>
    
    </div>
  )
}

export default Dashboard
